import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import Sidebar from './Sidebar';

import withRouter from 'components/Common/withRouter';
import { getIsServicePorviderExists } from 'api/clients/getIsServicePorviderExists';
import { useAppDispatch } from 'slices';
import { setIsCompanyActivated, setCompanySlug } from 'slices/sidebar/reducer';

const Layout = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchServiceProviderStatus = async () => {
      try {
        const response = await getIsServicePorviderExists();
        dispatch(setIsCompanyActivated(response.is_active));
        dispatch(setCompanySlug(response.my_company_slug));
      } catch (error) {
        console.error('Error fetching service provider status:', error);
      }
    };

    fetchServiceProviderStatus();
  }, [dispatch]);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.object,
};

export default withRouter(Layout);
